export const images = [
  {
    original: "https://picsum.photos/id/1024/1000/600/",
    thumbnail: "https://picsum.photos/id/1024/250/150/",
  },
  {
    original: "https://picsum.photos/id/1025/1000/600/",
    thumbnail: "https://picsum.photos/id/1025/250/150/",
  },
  {
    original: "https://picsum.photos/id/1026/1000/600/",
    thumbnail: "https://picsum.photos/id/1026/250/150/",
  },
  {
    original: "https://picsum.photos/id/1027/1000/600/",
    thumbnail: "https://picsum.photos/id/1027/250/150/",
  },
  {
    original: "https://picsum.photos/id/1029/1000/600/",
    thumbnail: "https://picsum.photos/id/1029/250/150/",
  },
];
